export default __webpack_public_path__ + "static/media/spark_59.5e8e5792.png";